// extracted by mini-css-extract-plugin
export default {"popover":"Tooltip_popover__VVBXb","box":"Tooltip_box__8VQx5","arrow":"Tooltip_arrow__iZOG0"};